import { CsI18n } from "../shared/csI18n/csI18n";
import { CsValidation as V } from "../shared/csValidationForm";
import { ChoiceList, TextField } from "@shopify/polaris";
import ChoiceHelper from "../helpers/ChoiceHelper";
import React from "react";

const ChoiceListWithChildren = (props) => {
  const {
    choices, masterListKey, subListKeys,
    handleChoiceListChange, handleChangeTextFieldOfChoice,
  } = props;

  const choiceList = choices.map((item) => {
    let choice = { label: CsI18n.t(item.label), value: item.key };
    if (typeof item.text === 'string') {
      choice.renderChildren = (isChoiceSelected) => {
        return isChoiceSelected &&
          <V>
            <TextField
              label="" placeholder={CsI18n.t(item.placeholder)} value={item.text}
              onChange={handleChangeTextFieldOfChoice(masterListKey, subListKeys, item.key)}
            />
            <V.Item rule="required" title={CsI18n.t("This field is required.")} />
          </V>
      };
    } else if (item.options && item.options.length) {
      choice.renderChildren = (isChoiceSelected) => {
        return isChoiceSelected &&
          <ChoiceListWithChildren
            title="" choices={item.options}
            masterListKey={masterListKey}
            subListKeys={[...subListKeys, item.key]}  // clone subListKeys and append this item key
            handleChoiceListChange={handleChoiceListChange}
            handleChangeTextFieldOfChoice={handleChangeTextFieldOfChoice}
          />
      }
    }
    return choice;
  });

  return (
    <ChoiceList
      allowMultiple title={props.title} choices={choiceList}
      selected={ChoiceHelper.selected(props.choices)}
      onChange={handleChoiceListChange(masterListKey, subListKeys)}
    />
  );
};

export default ChoiceListWithChildren;